<template>
  <div class="bxm-logo">
    <img class="bxm-logo-img" src="./assets/logo1.png" />
  </div>
  <div class="title"><a href="https://www.xinshuiyunshang.cn" target="_blank" rel="noopener noreferrer">新水云墒欢迎您</a></div>
</template>

<script>
// import logoImg from '@/assets/logo1.png';
export default {
  name: 'App',
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  text-align: center;
  .bxm-logo {
            box-sizing: border-box;
            width: 100%;
            height: 100%;
            padding: 10px 16px;
        }
        .bxm-logo-img {
            width: 200px;
            max-width: 100%;
            max-height: 100%;
            object-fit: contain;
        }
  .title {
    a {
      color: #165dff;
      font-size: 30px;
      font-weight: 900;
    }
  }
}
</style>
